var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPedidos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 17.8l3.75 2 3.75-2L18 19V4H6v15l2.25-1.2zm7.5 1.7l3.015 1.608a.5.5 0 0 0 .735-.441V3.5a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1v17.167a.5.5 0 0 0 .735.44L8.25 19.5l3.515 1.875a.5.5 0 0 0 .47 0L15.75 19.5z",
    fill: "#3F3E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.855 9.88c0-.458.371-.828.828-.828h6.462a.828.828 0 1 1 0 1.655H8.683a.828.828 0 0 1-.828-.828zM7.855 13.037c0-.457.371-.827.828-.827h6.462a.828.828 0 1 1 0 1.655H8.683a.828.828 0 0 1-.828-.828z",
    fill: "#3F3E3E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedidos);
export default __webpack_public_path__ + "static/media/pedidos.1cda3c1212b63b31a5df1e99241d38b7.svg";
export { ForwardRef as ReactComponent };